import { render } from "./FooterSiction.vue?vue&type=template&id=ee558200&scoped=true"
import script from "./FooterSiction.vue?vue&type=script&lang=js"
export * from "./FooterSiction.vue?vue&type=script&lang=js"

import "./FooterSiction.vue?vue&type=style&index=0&id=ee558200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee558200"]])

export default __exports__